import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-white" data-id="element-113" data-mp="1o3dmwcdeadr5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-114" data-mp="2223jzs07sdfi">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-teal bg-teal-soft text-ink" data-id="element-115" data-mp="1x3tk543joonk">
          <span className="font-display text-4xl font-extrabold leading-none" data-id="element-116" data-mp="19f0mn379y8qu">7</span>
          <span className="font-display text-xs font-bold uppercase tracking-widest" data-id="element-117" data-mp="14h8wadma2uor">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-118" data-mp="1j5va2aw9bedv">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-119" data-mp="1ebr3vtutfadu">
          Run your next practice from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-slate" data-id="element-120" data-mp="lodd6dhpnb26">
          Open Volume 1, print Session 1 and run it with your team. Try the
          Coach&apos;s Cue Cards courtside, and the 20-Minute Practice Picker the next
          time you&apos;re short on time. If 52 Weeks of Volleyball Practice Plans
          doesn&apos;t make your practices easier to plan and run, email us inside 7
          days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-121" data-mp="60nl7jr69ggl">
          {chips.map(chip => <li key={chip} className="rounded-full border border-cloud-dark px-4 py-2 text-[13px] text-slate" data-id="element-122" data-mp="azgwr6mwexe4">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}